import type { IStatusProps } from 'shared/ui/Status'
import {
  type IResponseOneTimeBroadcastStatus,
  type IResponseRecurringBroadcastStatus,
} from 'entities/Broadcast/api/types.ts'

const statuses: Record<
  IResponseOneTimeBroadcastStatus | IResponseRecurringBroadcastStatus,
  IStatusProps
> = {
  scheduled: {
    title: 'Scheduled',
    icon: 'clock',
    emphasis: 'high',
    intent: 'informative',
  },
  in_progress: {
    title: 'Sending',
    icon: 'pause',
    emphasis: 'high',
    intent: 'informative2',
  },
  pause: {
    title: 'Paused',
    icon: 'play',
    emphasis: 'high',
    intent: 'orange',
  },
  sent: {
    title: 'Finished',
    icon: 'check2',
    emphasis: 'high',
    intent: 'positive',
  },
  stopped: {
    title: 'Stopped',
    icon: 'minusCircle',
    emphasis: 'high',
    intent: 'neutral',
  },
  draft: {
    title: 'Draft',
    icon: 'draft',
    emphasis: 'high',
    intent: 'neutral',
  },
  failed: {
    title: 'Failed',
    icon: 'closeCircle',
    emphasis: 'high',
    intent: 'negative',
  },
  skipped: {
    title: 'Skipped',
    icon: 'closeCircle',
    emphasis: 'high',
    intent: 'negative',
  },
  active: {
    title: 'Active',
    icon: 'check2',
    emphasis: 'high',
    intent: 'informative2',
  },
  inactive: {
    title: 'Inactive',
    icon: 'minusCircle',
    emphasis: 'high',
    intent: 'neutral',
  },
  finished: {
    title: 'Finished',
    icon: 'check2',
    emphasis: 'high',
    intent: 'positive',
  },
  invalid: {
    title: 'Invalid',
    icon: 'closeCircle',
    emphasis: 'high',
    intent: 'negative',
  },
  restrict_hours_paused: {
    title: 'Idle hours',
    icon: 'clock',
    emphasis: 'high',
    intent: 'orange',
  },
}

export default statuses
